/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs */

const en__field_enum_csjensblank_unterstuezung_der_kariereplanung41 = /** @type {(inputs: _Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support in career planing`)
};

const de__field_enum_csjensblank_unterstuezung_der_kariereplanung41 = /** @type {(inputs: _Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung bei der Karriereplanung und -gestaltung`)
};

/**
* | output |
* | --- |
* | "Support in career planing" |
*
* @param {_Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_unterstuezung_der_kariereplanung41 = /** @type {((inputs?: _Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Unterstuezung_Der_Kariereplanung41Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_unterstuezung_der_kariereplanung41(inputs)
	return de__field_enum_csjensblank_unterstuezung_der_kariereplanung41(inputs)
});
export { _field_enum_csjensblank_unterstuezung_der_kariereplanung41 as "_field_enum_CSJENSBLANK_UNTERSTUEZUNG_DER_KARIEREPLANUNG" }